import { render, staticRenderFns } from "./RIDC.vue?vue&type=template&id=afa30204&scoped=true&"
import script from "./RIDC.vue?vue&type=script&lang=ts&"
export * from "./RIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa30204",
  null
  
)

export default component.exports